// import react from 'react';

export const Objective = () => {
    //return <div className="objective-container">Objective Component</div>;
  };

  export default Objective;